import { types } from 'mobx-state-tree';

const Invoices = types.model({
  hasValidSettings: false,
  isLoadingSettings: false,
});

export default Invoices;
